import { Component, OnInit, Input } from '@angular/core';
import { CmsService } from 'src/app/services/api/cms.service';
import { DomSanitizer } from '@angular/platform-browser';
import { WinService } from 'src/app/services/win.service';
import * as $ from 'jquery';

@Component({
  selector: 'app-ytvid',
  templateUrl: './ytvid.component.html',
  styleUrls: ['./ytvid.component.scss']
})
export class YtvidComponent implements OnInit {

	/* the block ID to be used default is 2 */
	staticBlockId: any = 2;
	@Input() blockId: any = 2;

	/* the block data was fetched */
	block: any = null;

	/* check if the get block was fired or not to prevent multi request */
	isFired: boolean = false;

	constructor(
		public winService: WinService,
		public cms: CmsService,
		public sanitizer: DomSanitizer
	) { }

	ngOnInit() {
		this.getBlock();
	}

	getBlock() {
		// if (!this.isFired || (this.isFired && this.staticBlockId != this.blockId)) {
			this.staticBlockId = this.blockId;
			this.isFired = true;

			this.cms.getBlock(this.blockId, false, true).then(f => {
				this.block = this.cms.cms['block_' + this.blockId];
				this.block.content.youembedlink = this.sanitizer.bypassSecurityTrustResourceUrl(this.block.content.youembedlink);

				setTimeout(() => {
					$('.anchor-el-link').on('click', (e) => {
						e.preventDefault();
						$([document.documentElement, document.body]).animate({
							scrollTop: $($(e.target).attr('href')).offset().top
						}, 500);
					});
				}, 500);
			});
		// }
	}
}
